export enum THEME_ENUM {
  DARK = 'dark-theme',
  LIGHT = 'light-theme',
}

export const DEFAULT_THEME = THEME_ENUM.DARK;

export const DAPP_URL = 'https://app.monday.trade/';

export const DOCS_URL = 'https://docs.monday.trade/';
